import React, { useEffect, useState, useRef } from "react";
import "./style.scss";

// import Button from "react-bootstrap/Button";
import logo from "../../../../../../../src/assets/images/MAARG-Logo.png";
import api from "../../../../../common/dependencies/utils/Api";

import launched from "../../../../../../../src/assets/images/launched.jpg";
import placepic from "../../../../../../../src/assets/images/placepic.png";
import Button from "../../../../../AdminModule/Dashboard/AdminDashboard/Button";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
// import { getPredefineOptionsList } from "../../../AdminDashboard/AdminMentorAction/dependencies/action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Select from "react-select";
import { useHistory } from "react-router-dom";
// import Button from "../../../AdminDashboard/Button";
import { Modal } from "react-bootstrap";
import DateTimeDisplay from "./DateTimeDisplay";
import { getCountersMentorList } from "../../dependencies/action";
import { LOGIN_POPUP_COHORT_COUNTER } from "../../../../../common/constants/ApplicationUrl";
// import { Countdown } from "../../NewCountdown/Countdown.js";

// import MultiselectorComp from "../../../../../MultiselectorComp/MultiselectorComp";
import {
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  TableBody,
} from "@material-ui/core";
import clsx from "clsx";
import makeStyles from "@material-ui/core/styles/makeStyles";
const customStyles = {
  control: (styles) => ({
    ...styles,
    backgroundColor: "rgba(0,0,0,0.05)",
    // paddingLeft: "10px",
    minHeight: "45px",
    // borderRadius: "var(--curve10)",
    color: "#333",
    // border: "1px solid #bfc0c1",
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: isSelected ? "#b499c7" : isFocused ? "#e4d7ee" : "white",
      color: isSelected ? "white" : "black",
      cursor: isDisabled ? "not-allowed" : "default",
    };
  },
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%",
    fontSize: "14px",
  }),
};
const styles = {
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: "rgba(0,0,0,0.2)",
      // backgroundColor:  isSelected &&isFocused ? "#b499c7" : "#b499c7",

      color: "#000",
    };
  },
};

const useStyles = makeStyles((theme) => ({
  tableRightBorder: {
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: "rgba(0,0,0,0.1)",
    borderStyle: "solid",
    borderTop: "1px solid lightgray",
    // whiteSpace: "nowrap",
  },
  smallWidth: {
    width: "300px",
    fontWeight: "bold",
    color: "#b499c7",
  },
  tableFont: {
    fontSize: "16px",
    fontFamily: "Montserrat",

    "&::before": {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  },
  tableContainer: {
    padding: "10px",
  },
  lessPadding: {
    padding: "3px 16px",
  },
}));

const NewModal = (props) => {
  const { getCountersMentorList, getCounterMentor } = props;
  let value = JSON.parse(localStorage.getItem("SavedLoggedInData"));

  const Match_time = new Date("January 11, 2023 00:00:00").getTime();
  const now = new Date().getTime();
  const Gap = Match_time - now;
  const { intentToMentor, createGroupSession } = props;
  const [timeOver, setTimeover] = useState(Gap < 0 ? true : false);
  // localStorage.setItem("timerStatus", "ON");
  const history = useHistory();
  const classes = useStyles();
  const handleClose = () => {
    props.setModalOpen(false);
  };

  // another way for timer

  const [timerDays, setTimerDays] = useState("00");
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");

  const [popupcohortcounter, setPopupcohortcounter] = useState();

  let interval = useRef();

  const Start_Timer = () => {
    // const Match_time = new Date("January 11, 2023 00:00:00").getTime();
    interval.current = setInterval(() => {
      // const now = new Date().getTime();
      // const Gap = Match_time - now;
      const TextDay = Math.floor(Gap / (1000 * 60 * 60 * 24));
      const TextHour = Math.floor(
        (Gap % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const TextMinute = Math.floor((Gap % (1000 * 60 * 60)) / (1000 * 60));
      const TextSecond = Math.floor((Gap % (1000 * 60)) / 1000);

      if (Gap < 0) {
        //Stop Timer
        setTimeover(true);
        clearInterval(interval.current);
        // props.setModalOpen(false);
      } else {
        //Set Timer
        setTimeover(false);
        setTimerDays(TextDay);
        setTimerHours(TextHour);
        setTimerMinutes(TextMinute);
        setTimerSeconds(TextSecond);
      }
    }, 1000);
  };
  useEffect(() => {
    api
      .POST(LOGIN_POPUP_COHORT_COUNTER, {
        id:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        // const cohortnameArray = [];

        // setCohortAdminCounter(res.data.data);
        setPopupcohortcounter(res.data.data);
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    let params = {
      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getCountersMentorList(params);
  }, []);
  useEffect(() => {
    Start_Timer();
    return () => {
      clearInterval(interval.current);
    };
  });

  const NewCount = () => {
    return (
      <div className="heightmax">
        {/* <h3 style={{ textAlign: "center", padding: "1% 0%" }}>
              {`${timerDays && timerDays} days to go!!`}
            </h3> */}
        <p className="py-3">
          {/* All Mentorship features will be enabled from 16th jan 2023..
              please stay tuned and Visit the Mentor startup Dashboard */}
          The matchmaking feature has been enabled on MAARG! You may accept the
          startup requests and reach out to startups matching your requirements
          today!
        </p>
        {getCounterMentor && getCounterMentor.pending > 0 ? (
          <div>
            <p className="px-5" style={{ paddingBottom: "15px" }}>
              {" "}
              You have received{" "}
              <span
                style={{
                  fontWeight: "bold",
                  color: "#3ac2d7",
                  fontSize: "22px",
                }}
              >
                {" "}
                {getCounterMentor && getCounterMentor.pending}
              </span>{" "}
              requests from Startups.{" "}
              <span
                style={{
                  // fontWeight: "bold",
                  // color: "#3ac2d7",
                  // fontSize: "22px",
                  cursor: "pointer",
                }}
                className="popuphoverclicktoview"
                onClick={() => {
                  localStorage.setItem("myrequestMenu", "myrequestMenu");

                  window.location.reload();
                  history.push({
                    state: {
                      prevPage: "mentorDashboard",
                    },
                  });
                }}
              >
                Click here
              </span>{" "}
              to view requests and respond.
            </p>
            {/* <div className="row">
              <div className="newuserTooltip">
                <Button
                  text="Respond"
                  className="respond-btnText top-btn"
                  onClick={() => {
                    localStorage.setItem("myrequestMenu", "myrequestMenu");

                    window.location.reload();
                    history.push({
                      state: {
                        prevPage: "mentorDashboard",
                      },
                    });
                  }}
                ></Button>
                <span
                  className="tooltiptext tooltip-bottom"
                  style={{
                    width: "150px",
                    top: "32px",
                    paddingTop: "4px",
                    left: "47%",
                  }}
                >
                  Click to Respond
                </span>
              </div>
              {popupcohortcounter && popupcohortcounter.active > 0 && (
                <div className="newuserTooltip">
                  <Button
                    text="View Cohorts"
                    className="respond-btnText top-btn"
                    // onClick={() => {
                    //   localStorage.setItem("myrequestMenu", "myrequestMenu");

                    //   window.location.reload();
                    //   history.push({
                    //     state: {
                    //       prevPage: "mentorDashboard",
                    //     },
                    //   });
                    // }}
                  ></Button>
                  <span
                    className="tooltiptext tooltip-bottom"
                    style={{
                      width: "150px",
                      top: "32px",
                      paddingTop: "4px",
                      left: "47%",
                    }}
                  >
                    View Cohorts
                  </span>
                </div>
              )}
            </div> */}
          </div>
        ) : (
          ""
        )}
        {popupcohortcounter && popupcohortcounter.active > 0 ? (
          <div>
            <p className="px-5" style={{ paddingBottom: "15px" }}>
              {" "}
              {/* You have received{" "} */}
              <span
                style={{
                  fontWeight: "bold",
                  color: "#3ac2d7",
                  fontSize: "22px",
                }}
              >
                {" "}
                {popupcohortcounter && popupcohortcounter.active}
              </span>{" "}
              new Cohorts are now created.{" "}
              <span
                style={{
                  // fontWeight: "bold",
                  // color: "#3ac2d7",
                  // fontSize: "22px",
                  cursor: "pointer",
                }}
                className="popuphoverclicktoview"
                onClick={() => {
                  // history.push("/cohort-program");
                  history.push({
                    pathname: "/cohort-program",
                    state: {
                      fromPage: "mentorDashboard",
                    },
                  });
                }}
              >
                Click here
              </span>{" "}
              to view the cohorts.
            </p>
            {/* <div className="newuserTooltip">
              <Button
                text="View Cohorts"
                className="respond-btnText top-btn"
                // onClick={() => {
                //   localStorage.setItem("myrequestMenu", "myrequestMenu");

                //   window.location.reload();
                //   history.push({
                //     state: {
                //       prevPage: "mentorDashboard",
                //     },
                //   });
                // }}
              ></Button>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  width: "150px",
                  top: "32px",
                  paddingTop: "4px",
                  left: "47%",
                }}
              >
                View Cohorts
              </span>
            </div> */}
          </div>
        ) : (
          ""
        )}
        {/* <div className="row">
          {getCounterMentor && getCounterMentor.pending > 0 && (
            <div className="newuserTooltip col-md-6 col-sm-12 respondbtnreq">
              <Button
                text="Respond"
                className="respond-btnText top-btn"
                onClick={() => {
                  localStorage.setItem("myrequestMenu", "myrequestMenu");

                  window.location.reload();
                  history.push({
                    state: {
                      prevPage: "mentorDashboard",
                    },
                  });
                }}
              ></Button>
              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  width: "150px",
                  top: "32px",
                  paddingTop: "4px",
                  left: "47%",
                }}
              >
                Click to Respond
              </span>
            </div>
          )}

          {popupcohortcounter && popupcohortcounter.active > 0 && (
            <div className="newuserTooltip col-md-6 col-sm-12">
              <Button
                text="View Cohorts"
                className="respond-btnText top-btn"
                // onClick={() => {
                //   localStorage.setItem("myrequestMenu", "myrequestMenu");

                //   window.location.reload();
                //   history.push({
                //     state: {
                //       prevPage: "mentorDashboard",
                //     },
                //   });
                // }}
                onClick={() => {
                  // history.push("/cohort-program");
                  history.push({
                    pathname: "/cohort-program",
                    state: {
                      fromPage: "mentorDashboard",
                    },
                  });
                }}
              ></Button>

              <span
                className="tooltiptext tooltip-bottom"
                style={{
                  width: "150px",
                  top: "32px",
                  paddingTop: "4px",
                  left: "47%",
                }}
              >
                View Cohorts
              </span>
            </div>
          )}
        </div> */}
      </div>
    );
  };

  return (
    <>
      {timeOver === true && value?.role === "Mentor" && (
        <Modal
          backdrop="static"
          keyboard={false}
          size="lg"
          show={props.modalOpen}
          onHide={() => props.setModalOpen(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{
            borderRadius: "7px",
            // visibility: timeOver === false ? "hidden" : "visible",
          }}
          className={
            timeOver === false
              ? "meinmodalcontainercountdown2"
              : "meinmodalcontainercountdowntimeover2"
          }
        >
          <Modal.Header className="d-flex ">
            <img src={logo} style={{ width: "15%" }} />
            <Modal.Title
              className="modalHeadingncountdown"
              // style={{ visibility: "hidden" }}
            >
              {value?.role === "Mentor" ? "Mentors" : "Startups"}
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-110px", top: "2px", width: "115px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            {/* <div>hello</div> */}
            <NewCount />

            {/* <Countdown /> */}
            {/* <div>
            <DateCountdown
              dateTo="January 12, 2023 00:00:00"
              callback={() => alert("Launched")}
            />
          </div> */}
            {/* <Countdown /> */}
          </Modal.Body>
          <Modal.Footer
            className="countdownmodalfooter"
            style={{ borderTop: "none" }}
            // style={{ justifyContent: "center" }}
          >
            {/* <Button
            style={{ width: "20%" }}
            variant="primary"
            onClick={handleClose}
          >
            Close
          </Button> */}
            {/* <Button
  
            onClick={handleClose}
            text="CLOSE"
            className="modalButton51 doc-upload newcolornow"
          ></Button> */}
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getCounterMentor: state.MentorReducer.getCountersMentorList.data,
  };
};
export default connect(mapStateToProps, {
  getCountersMentorList,
})(withRouter(NewModal));
